import React from 'react';
import { Github, ExternalLink, Heart } from 'lucide-react';

function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 mt-16">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Universal Cross-Language Developer Assistant
            </h3>
            <p className="text-gray-600 mb-4">
              Empowering developers with AI-powered cross-language project analysis, migration suggestions, and intelligent code transformation tools.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://github.com/yourusername/universal-dev-assistant"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <Github className="w-5 h-5" />
              </a>
              <a
                href="https://api.fastpm.dev"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <ExternalLink className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="/health" className="text-gray-600 hover:text-primary-600 transition-colors">
                  Health Status
                </a>
              </li>
              <li>
                <a href="/analyze" className="text-gray-600 hover:text-primary-600 transition-colors">
                  Project Analysis
                </a>
              </li>
              <li>
                <a href="/ai-routing" className="text-gray-600 hover:text-primary-600 transition-colors">
                  AI Routing
                </a>
              </li>
              <li>
                <a href="/suggestions" className="text-gray-600 hover:text-primary-600 transition-colors">
                  Suggestions
                </a>
              </li>
            </ul>
          </div>

          {/* API Resources */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">API Resources</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://api.fastpm.dev/health"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-primary-600 transition-colors"
                >
                  API Documentation
                </a>
              </li>
              <li>
                <a
                  href="https://api.fastpm.dev/metrics"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-primary-600 transition-colors"
                >
                  System Metrics
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/cloudflare/workers-sdk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-primary-600 transition-colors"
                >
                  Cloudflare Workers
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm">
              © 2025 Universal Developer Assistant. Built with{' '}
              <Heart className="w-4 h-4 inline text-red-500 mx-1" />
              using Cloudflare Workers.
            </p>
            <div className="flex items-center space-x-4 mt-4 md:mt-0">
              <span className="text-sm text-gray-500">
                Powered by{' '}
                <a
                  href="https://fastpm.dev"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-600 hover:text-primary-700 font-medium"
                >
                  FastPM.dev
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;